import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfig} from '@models/app-config.model';
import {GenericFunctionsUtil} from '@core/src/public-api';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  appConfig: AppConfig;

  constructor(
    private http: HttpClient
  ) {
  }

  async init(): Promise<any> {
    this.appConfig = await this.getConfigurationsBack();
  }

  async getConfigurations(): Promise<AppConfig> {
    if (this.appConfig) {
      return this.appConfig;
    }

    this.appConfig = await this.getConfigurationsBack();
    return this.appConfig;
  }

  private getConfigurationsBack(): Promise<AppConfig> {
    const url = `/api/v1/configurations`;
    return this.http.get<AppConfig>(url).toPromise();
  }

  getVariableValue(name: string): string {
    if (!this.appConfig?.configurationVariables?.length) {
      return;
    }

    return this.appConfig.configurationVariables.find(variable => variable.name === name)?.value;
  }

  hasConfigurationEnabled(configurationKey: string): boolean {
    const boolText = this.getVariableValue(configurationKey);
    return boolText === 'true' || boolText === 'True';
  }

  hasConfigurationsEnabled(configurationKeys: string[], operation = 'and'): boolean {
    if (operation === 'and') {
      return configurationKeys.every(key => this.hasConfigurationEnabled(key));
    }

    if (operation === 'or') {
      return !!configurationKeys.find(key => this.hasConfigurationEnabled(key));
    }
  }

  resetAppConfig(): void {
    this.appConfig = null;
  }

  filterItemsByConfigurations(originalItems: any[]): any {
    let items = GenericFunctionsUtil.deepClone(originalItems);
    items = items.filter(item => {
      if (!item.configurationKeys) {
        return true;
      }

      return this.hasConfigurationsEnabled(item.configurationKeys, item.configurationKeysOperation);
    });

    return items;
  }
}
